import React from 'react';

function VersionNumber() {
    return <p className='version-number'>v1.3.0</p>;
}

export default VersionNumber;
